<div class="bg-dark bg-dark-login">
        <br>
        <h1 class="font-container">Olá {{account.firstName}}!</h1>
        <p class="font-container">Você está logado com Angular 10 e JWT!!</p>
</div>
